<template>
<div class="sendNoticeVue">
 <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Generate Tiny Url</h1>
                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="col-md-6 col-md-offset-3">
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                    
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">URL:</label>
                                <input type="text" class="form-control" placeholder="Enter Full URL" v-validate="{ required: true}" name="subject" v-model="fullUrl">
                                <span v-show="errors.has('subject') && this.validation_err!=0" class="err-msg">{{ errors.first('subject') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-center">
                                <ul class="o-filter-area">
                                    <li>
                                        <a href="javascript: void(0)" @click="backToDashboard()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" @click="sendRequest()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-download"></i> Generate</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Result:</label>
                                <textarea class="form-control u-border-radius-0" rows="3" placeholder="Result" name="message" v-model="result"></textarea>

                            </div>
                        </div>
                    </div>
                    


                </div>
            </div>
        </div>
</div>

</template>
<script>
    import {
        bus
    } from '../../main';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        data() {
            return {
                validation_err: 0,
                fullUrl:'',
                result:'',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken'
            })
        },
        methods: {

            backToDashboard() {
                this.$router.push({
                    'path': '/clientList'
                });
            },
            sendRequest() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        console.log("success");
                        service.post('getTinyUrl', {
                            'url':this.fullUrl
                        }, {
                            'Authorization': this.userToken
                        })
                        .then((res) => {
                            this.result=res.data.result;
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Tiny Url Generated successfully',
                                type: 'success'
                            });
                        }).catch((err) => {
                            this.$notify({
                                title: this.$t('error'),
                                message: 'Sorry! something went wrong.',
                                type: 'error'
                            });
                        });


                        //console.log(fromData);
                    } else {
                        this.validation_err = 1;
                        console.log("error");
                    }
                });
            },
            
        },
        created() {
            this.$Progress.start();
            service.get('client', {
                'Authorization': this.userToken
            })
            .then((res) => {
                this.$Progress.finish();
                //console.log("client", res.data.result.data);
                this.clients = res.data.result.data;
                for (var i = 0; i < this.clients.length; i++) {
                    this.sendNotice.sendid.push(this.clients[i].user.email);
                    this.sendNotice.bcc.push(this.clients[i].user.email);
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }

</script>
<style scoped>


</style>
